import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole = 'admin' }) => {
  // Check if user is authenticated based on stored tokens
  const isAdminAuthenticated = () => {
    const adminToken = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
    const adminId = localStorage.getItem('adminId') || sessionStorage.getItem('adminId');
    const userRole = localStorage.getItem('userRole') || sessionStorage.getItem('userRole');
    
    return adminToken && adminId && userRole === 'admin';
  };

  const isVolunteerAuthenticated = () => {
    const userId = localStorage.getItem('userId') || sessionStorage.getItem('userId');
    const userStatus = localStorage.getItem('userStatus') || sessionStorage.getItem('userStatus');
    
    return userId && userStatus;
  };

  const isInternAuthenticated = () => {
    const internToken = localStorage.getItem('internToken') || sessionStorage.getItem('internToken');
    const userType = localStorage.getItem('userType') || sessionStorage.getItem('userType');
    const internData = localStorage.getItem('internData') || sessionStorage.getItem('internData');
    
    // console.log('Intern auth check:', { internToken: !!internToken, userType, internData: !!internData });
    
    return internToken && userType === 'intern' && internData;
  };

  // Check authentication based on required role
  if (requiredRole === 'admin') {
    if (!isAdminAuthenticated()) {
      return <Navigate to="/admin/login" replace />;
    }
  } else if (requiredRole === 'volunteer') {
    if (!isVolunteerAuthenticated()) {
      return <Navigate to="/login" replace />;
    }
  } else if (requiredRole === 'intern') {
    if (!isInternAuthenticated()) {
      return <Navigate to="/intern/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
